export const isMoreThan3Days = (from: Date, to: Date): boolean => {
  const diff = to.getTime() - from.getTime();
  const threeDaysInMs = 3 * 24 * 60 * 60 * 1000;
  const result = diff > threeDaysInMs;

  return result;
};
